var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 17.3337V11.3337C28.3327 9.56555 27.6303 7.86986 26.3801 6.61961C25.1298 5.36937 23.4341 4.66699 21.666 4.66699H10.3327C8.56457 4.66699 6.86888 5.36937 5.61864 6.61961C4.36839 7.86986 3.66602 9.56555 3.66602 11.3337V20.667C3.66602 21.5425 3.83845 22.4094 4.17349 23.2182C4.50852 24.0271 4.99958 24.762 5.61864 25.381C6.86888 26.6313 8.56457 27.3337 10.3327 27.3337H18.6793",
    stroke: "#F79C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01172 22.6672L7.66505 18.4005C8.14484 17.924 8.77453 17.6279 9.44756 17.5623C10.1206 17.4967 10.7956 17.6656 11.3584 18.0405C11.9212 18.4154 12.5962 18.5843 13.2692 18.5187C13.9422 18.4531 14.5719 18.157 15.0517 17.6805L18.1584 14.5738C19.051 13.6781 20.2329 13.1288 21.4931 13.0238C22.7533 12.9187 24.0098 13.2649 25.0384 14.0005L28.3317 16.5472M10.6784 13.5605C10.969 13.5587 11.2565 13.4998 11.5244 13.3869C11.7922 13.2741 12.0353 13.1096 12.2395 12.9028C12.4438 12.696 12.6054 12.4511 12.715 12.1819C12.8246 11.9126 12.8801 11.6245 12.8784 11.3338C12.8766 11.0432 12.8177 10.7557 12.7048 10.4878C12.592 10.22 12.4275 9.97696 12.2207 9.77267C12.0139 9.56838 11.7689 9.40682 11.4997 9.29721C11.2305 9.18759 10.9424 9.13208 10.6517 9.13383C10.0647 9.13737 9.50314 9.37395 9.09056 9.79153C8.67798 10.2091 8.44818 10.7735 8.45172 11.3605C8.45526 11.9475 8.69184 12.5091 9.10942 12.9217C9.527 13.3342 10.0914 13.564 10.6784 13.5605Z",
    stroke: "#F79C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9414 20V26.6667",
    stroke: "#F79C00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 22.8073L25.3768 20.1847C25.32 20.1271 25.2523 20.0814 25.1777 20.0502C25.103 20.019 25.023 20.0029 24.9421 20.0029C24.8612 20.0029 24.7812 20.019 24.7065 20.0502C24.6319 20.0814 24.5642 20.1271 24.5074 20.1847L21.8848 22.8073",
    stroke: "#F79C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/image-upload-icon.fb5660870cc7ef7e125a187bb102b0ca.svg";
export { ForwardRef as ReactComponent };